import COLOR from './Colors'
import convertLength from 'convert-css-length'

/**
 * Convert from px to rem
 * @param {int} x
 */
export const px2Rem = (x) => {

  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
  const convert = convertLength('16px')

  // Convert to rem
  return convert(`${x}px`, 'rem')
}

/**
 * Style a box has background-color
 * @param {string} width
 * @param {string} height
 * @param {string} bgColor color code
 */
export const box = (width, height, bgColor = COLOR.white) => {
  return `
    width: ${width};
    height: ${height};
    background-color: ${bgColor}
  `
}

/**
 * Wrapping flexbox attributes: align-items and justify-content
 * @param {string} alignItems values: flex-start | flex-end | center | baseline | stretch;
 * @param {string} justifyContent values: flex-start | flex-end | center | space-between
 * | space-around | space-evenly;
 *  @param {string} flexWrap values: nowrap | wrap | wrap-reverse;
 */
export const flexContainer = (alignItems = 'center', justifyContent = '', flexWrap = '', flexDirection = '') => {
  return `
    display: flex;
    flex-direction: ${flexDirection};
    align-items: ${alignItems};
    justify-content: ${justifyContent};
    flex-wrap: ${flexWrap};
  `
}

/**
 * Wrapping flex item attribute: align-self and  flex-grow
 * @param {string} align auto | flex-start | flex-end | center | baseline | stretch
 * @param {number} flexGrow number
 * @param {number} order
 */
export const flexItem = (align = 'auto', flexGrow = 0, order = '') => {
  return `
    align-self: ${align};
    flex-grow: ${flexGrow};
    order: ${order};
  `
}

/**
 * Create position (top, left, right, bottom) for absoute element
 * @param {int} top
 * @param {int} left
 * @param {int} right
 * @param {int} bottom
 */
export const basePosition = (top = 0, left = 0, right = 0, bottom = 0) => {
  return `
    top: ${top};
    left: ${left};
    right: ${right};
    bottom: ${bottom};
  `
}

/**
 * Create box shadow (value) for element
 * @param {int} value
 */
export const boxShadow = (value) => {
  return {
    '-o-box-shadow': `${value}`,
    '-ms-box-shadow': `${value}`,
    '-moz-box-shadow': `${value}`,
    '-webkit-box-shadow': `${value}`,
    'box-shadow': `${value}`
  }
}

/**
 * Create box truncate (value) for element
 * @param {int} value
 */
export const boxTruncate = (width, height, lineHeight, overflow, padding) => {
  return {
    'max-width': `${width}`,
    'height': `${height}`,
    'line-height': `${lineHeight}`,
    'overflow': `${overflow}`,
    'padding': `${padding}`
  }
}

/**
 * Create background image (bgimage, bgRepeat, bgPosition, bgSize) for absoute element
 * @param {string} bgimage
 * @param {string} bgRepeat
 * @param {string} bgPosition
 * @param {string} bgSize
 */
export const backgroundImage = (bgimage, bgRepeat, bgPosition, bgSize) => {
  return {
    'background-image': `url(${bgimage})`,
    'background-repeat': `${bgRepeat}`,
    'background-position': `${bgPosition}`,
    'background-size': `${bgSize}`
  }
}



// WEBPACK FOOTER //
// ./src/themes/Mixins.js